// Stage 33: Bulletin Canvas — top-level route component.
// Renders inside AuthedApp under `view === 'bulletin'`.

import { useBulletinPolling } from './useBulletinPolling';
import { BulletinCanvas } from './BulletinCanvas';

export function BulletinRoute(): JSX.Element {
  const { panels, setPanels, error, refresh } = useBulletinPolling();

  return (
    <div className="bulletin-route">
      <header className="bulletin-toolbar">
        <h2>Bulletin Board</h2>
        <span className="muted small">
          {panels.length} panel{panels.length === 1 ? '' : 's'} &middot;{' '}
          {panels.filter((p) => p.linkedYesterdayId).length} bound
        </span>
        {error ? (
          <span className="bulletin-error small">⚠ {error}</span>
        ) : null}
        <button type="button" onClick={() => void refresh()}>
          Refresh
        </button>
      </header>
      <BulletinCanvas
        panels={panels}
        setPanels={setPanels}
        refresh={refresh}
      />
    </div>
  );
}
